// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navbar{position:fixed;top:0;left:0;right:0;z-index:1000}body{margin:0}#app,body,html{overflow-x:hidden}#app{height:100vh;width:100%;overflow-y:hidden}@media screen and (max-width:768px){#app{height:100%}}::-webkit-scrollbar{width:0;height:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
